// Copyright (c) 2017 Deere & Company

const laborRateChangesSortOptions = [
    {
        displayName: 'REQUESTED',
        path: ['requestDate']
    }
];

export default laborRateChangesSortOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/labor-rate-changes-sort-options.js